import { AppRemixIcon } from '@/layout/AppComponents';
import colors from "../../../constants/colors";

export default function SpinnerLoader(props) {
  const { size = "20", color = colors.primary } = props;

  return (
    <div className="loader-block">
      <AppRemixIcon icon="loader-4" size={size} color={color} />
    </div>
  );
}
